import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { getStatusColor, getIssueTypeBadgeClasses } from './utils/styleUtils';
import { formatHours } from './utils/roundUtils';

const GroupHeader = ({ 
  group, 
  groupKey, 
  groupingField, 
  isExpanded, 
  onToggle 
}) => {
  return (
    <div 
      className="px-3 sm:px-4 py-3 bg-gray-50 hover:bg-gray-100 dark:bg-slate-700/30 dark:hover:bg-slate-700/50 cursor-pointer flex items-start sm:items-center justify-between gap-3"
      onClick={onToggle}
    >
      <div className="flex-1 min-w-0 pr-2">
        <div className="flex flex-col gap-2">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm font-medium text-gray-900 dark:text-slate-100 truncate">
              {group.label || groupKey}
            </span>
            {groupingField === 'issue' && group.issue_status && (
              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium flex-shrink-0 ${getStatusColor(group.issue_status)}`}>
                {group.issue_status}
              </span>
            )}
            {groupingField === 'Parent' && (
              <>
                {!group.isStandaloneIssue && group.parentType && (
                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs border flex-shrink-0 ${getIssueTypeBadgeClasses(group.parentType)}`}>
                    {group.parentType}
                  </span>
                )}
                {group.isStandaloneIssue && group.issue_type && (
                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs border flex-shrink-0 ${getIssueTypeBadgeClasses(group.issue_type)}`}>
                    {group.issue_type}
                  </span>
                )}
              </>
            )}
          </div>
          {group.issue_summary && (
            <span className="text-sm text-gray-600 dark:text-slate-400 block truncate">
              {group.issue_summary}
            </span>
          )}
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/30 px-2 py-1 rounded whitespace-nowrap">
              {formatHours(group.totalHours)}h logged
            </span>
            <span className="text-xs text-green-600 bg-green-50 dark:text-green-400 dark:bg-green-900/30 px-2 py-1 rounded whitespace-nowrap">
              {formatHours(group.totalEstimated)}h estimated
            </span>
            <span className="text-xs text-purple-600 bg-purple-50 dark:text-purple-400 dark:bg-purple-900/30 px-2 py-1 rounded whitespace-nowrap">
              {group.totalEntries} entries
            </span>
            {group.uniqueIssuesCount !== undefined && (
              <span className="text-xs text-orange-600 bg-orange-50 dark:text-orange-400 dark:bg-orange-900/30 px-2 py-1 rounded whitespace-nowrap">
                {group.uniqueIssuesCount} issues
              </span>
            )}
            {group.uniqueAuthors !== undefined && (
              <span className="text-xs text-indigo-600 bg-indigo-50 dark:text-indigo-400 dark:bg-indigo-900/30 px-2 py-1 rounded whitespace-nowrap">
                {group.uniqueAuthors} {groupingField === 'issue' ? 'authors' : 'members'}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="flex-shrink-0 mt-1 sm:mt-0">
        {isExpanded ? (
          <ChevronDown className="w-5 h-5 text-gray-400 dark:text-slate-400" />
        ) : (
          <ChevronRight className="w-5 h-5 text-gray-400 dark:text-slate-400" />
        )}
      </div>
    </div>
  );
};

export default GroupHeader;

